import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=6d8acc5c&scoped=true"
import script from "./BaseAlert.vue?vue&type=script&lang=js"
export * from "./BaseAlert.vue?vue&type=script&lang=js"
import style0 from "./BaseAlert.vue?vue&type=style&index=0&id=6d8acc5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8acc5c",
  null
  
)

export default component.exports